import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { DeliveriesService } from 'src/app/services/deliveries.service';
import { MetaService } from 'src/app/services/meta.service';
import { OrdersService } from 'src/app/services/orders.service';

import * as moment from 'moment';

@Component({
  selector: 'app-dialog-edit-delivery-dates',
  templateUrl: './dialog-edit-delivery-dates.component.html',
  styleUrls: ['./dialog-edit-delivery-dates.component.css']
})
export class DialogEditDeliveryDatesComponent implements OnInit {

  public deliveries = [];
  public dateOne = '';
  public dateTwo = '';
  public dateThree = '';
  public dateFour = '';
  public deliveryOnePending: boolean;
  public deliveryTwoPending: boolean;
  public deliveryThreePending: boolean;
  public deliveryFourPending: boolean;

  deliveryDays = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private deliveriesService: DeliveriesService, private ordersService: OrdersService, private META_DATA: MetaService, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  myFilter = (d: Date | null): boolean => {

    const day = (d || new Date()).getDay();
    const date = (d || new Date()).getDate();
    const todayDate = new Date().getDate();

    let days = this.deliveryDays;


    if (days.length == 1) {
      return day !== days[0] && date !== todayDate;
    }

    if (days.length == 2) {
      return day !== days[0] && day !== days[1] && date !== todayDate;
    }

    if (days.length == 3) {
      return day !== days[0] && day !== days[1] && day !== days[2] && date !== todayDate;
    }

    if (days.length == 4) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && date !== todayDate;
    }

    if (days.length == 5) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && date !== todayDate;
    }

    if (days.length == 6) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && day !== days[5] && date !== todayDate;
    }

    if (days.length == 7) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && day !== days[5] && day !== days[6] && date !== todayDate;
    }
  }

  ngOnInit() {
    this.deliveries = this.data.deliveries;

    this.META_DATA.getMetaData().subscribe(result => {
      if (result.success) {
        this.deliveryDays = result.data.invalidDeliveryDays;
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    let nextDeliveryDates = [];

    this.data.deliveries.map(delivery => {
      const splitDate = delivery.deliveryDate.split('-');
      const newDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;

      let pending;
      if (delivery.status === 'Pending') {
        pending = true;
      } else {
        pending = false;
      };

      const data = {
        date: newDate,
        pending: pending
      }

      nextDeliveryDates.push(data);
    });

    this.dateOne = nextDeliveryDates[0].date;
    this.dateTwo = nextDeliveryDates[1].date;
    this.dateThree = nextDeliveryDates[2].date;
    this.dateFour = nextDeliveryDates[3].date;

    this.deliveryOnePending = nextDeliveryDates[0].pending;
    this.deliveryTwoPending = nextDeliveryDates[1].pending;
    this.deliveryThreePending = nextDeliveryDates[2].pending;
    this.deliveryFourPending = nextDeliveryDates[3].pending;
  }

  onUpdate() {
    const dates = [moment(this.dateOne).format('DD-MM-YYYY'), moment(this.dateTwo).format('DD-MM-YYYY'), moment(this.dateThree).format('DD-MM-YYYY'), moment(this.dateFour).format('DD-MM-YYYY')];

    const data = new FormData();
    data.append('order', this.data._id);
    data.append('deliveryDates', JSON.stringify(dates));

    this.deliveriesService.updateDeliveryDatesAsUser(data).subscribe(result => {
      if (result.success) {
        this.ordersService.getAllOrders({ status: "Pending" }).subscribe(result => {
          this.ordersService.setOrders(result.data);
          this.dialog.closeAll();
          this.snackBar.open('Delivery dates updated successfully', 'Dismiss', {
            duration: 3000
          });
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onUpdateSingleDate() {
    const dates = moment(this.dateOne).format('DD-MM-YYYY');

    const data = new FormData();
    data.append('_id', this.data._id);
    data.append('deliveryDate', dates);

    this.deliveriesService.updateSingleDeliveryDateAsAUser(data).subscribe(result => {
      if (result.success) {
        this.ordersService.getAllOrders({ status: "Pending" }).subscribe(result => {
          this.ordersService.setOrders(result.data);
          this.dialog.closeAll();
          this.snackBar.open('Delivery dates updated successfully', 'Dismiss', {
            duration: 3000
          });
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }
}
